// De tags die het LLM in zijn antwoord emit, en hoe je ze eruit haalt.
// Bewust vrij van `config` (en dus van `window`): de streamende chat draait deze
// functies op elke delta, en de tests ervoor moeten zonder DOM kunnen draaien.
// De backend heeft een spiegel hiervan in ca_project/project/chat_filters.py.

// Haalt de tag `<name>…</name>` uit de tekst. Ook tijdens het streamen
// bruikbaar: een tag die nog niet is afgesloten — of waarvan pas "<filt" binnen
// is — wordt ook verborgen, anders ziet de gebruiker de ruwe JSON voorbijkomen.
function stripTag(text: string, name: string): string {
  const openTag = `<${name}>`;
  let out = text.replace(new RegExp(`<${name}>[\\s\\S]*?</${name}>\\s*`), "");

  const open = out.indexOf(openTag);
  if (open !== -1) return out.slice(0, open).trim();

  for (let i = openTag.length - 1; i > 0; i--) {
    if (out.endsWith(openTag.slice(0, i))) {
      out = out.slice(0, -i);
      break;
    }
  }
  return out.trim();
}

export const stripFilterTag = (text: string) => stripTag(text, "filters");
export const stripResearchTag = (text: string) => stripTag(text, "research");
export const stripReportTag = (text: string) => stripTag(text, "report");

/** Alle voorstel-tags weg: wat overblijft is wat de gebruiker leest. */
export const stripProposalTags = (text: string) =>
  stripReportTag(stripResearchTag(stripFilterTag(text)));
